import React, { useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCheck, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import api from "../../services/api";
import "./FluxopayOperationalAlerts.css";

export default function FluxopayOperationalAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [hidden, setHidden] = useState(false);
  const [busy, setBusy] = useState(null);
  const load = useCallback(async () => {
    try {
      const response = await api.get("/api/fluxopay/operational-alerts");
      setAlerts(response.data.alerts || []); setHidden(false);
    } catch (error) {
      if (error?.response?.status === 403) setHidden(true);
    }
  }, []);
  useEffect(() => { load(); const timer = setInterval(load, 60000); return () => clearInterval(timer); }, [load]);
  const acknowledge = async (alert) => {
    setBusy(alert.uuid);
    try { await api.post(`/api/fluxopay/operational-alerts/${alert.uuid}/acknowledge`); await load(); }
    finally { setBusy(null); }
  };
  if (hidden || alerts.length === 0) return null;
  return <section className="fpoa"><header><FontAwesomeIcon icon={faBell} /><div><strong>Atenção aos seus repasses</strong><p>{alerts.filter((item) => item.status === "open").length} alerta(s) financeiro(s) precisam de acompanhamento.</p></div></header><div>{alerts.slice(0, 5).map((alert) => <article key={alert.uuid} className={`is-${alert.severity}`}><FontAwesomeIcon icon={faCircleExclamation} /><div><strong>{alert.title}</strong><p>{alert.message}</p></div>{alert.status === "open" && <button disabled={busy === alert.uuid} onClick={() => acknowledge(alert)}><FontAwesomeIcon icon={faCheck} /> Entendi</button>}</article>)}</div></section>;
}
